import { get } from 'lodash'

const TOOLKIT_API_HEADERS = {
  'X-Api-Key': process.env.TOOLKIT_API_KEY,
}

const MIN_PASSWORD_LENGTH = 8

const getFieldErrorsMessage = (error: any) => {
  const fieldErrors: string[] = []

  const errors = get(error, 'response.data.errors', {})
  for (const [, messages] of Object.entries(errors)) {
    const errorMessages = messages as string[]
    errorMessages.forEach(message => fieldErrors.push(`- ${message}`))
  }

  return fieldErrors.join('\n')
}

export { TOOLKIT_API_HEADERS, MIN_PASSWORD_LENGTH, getFieldErrorsMessage }
